<template>
  <div class="investment">
    <v-tabs v-model="currentTab">
      <v-tabs-items v-model="currentTab">
        <v-tab-item>
          <v-form class="mt-4" ref="form" v-model="isFormValid" lazy-validation>
            <v-row>
              <v-col cols="4" :style="{ maxWidth: formMaxWidth + 'px' }">
                <div>
                  <v-select
                    v-model="investStatus"
                    :items="investStatusList"
                    label="Investment status"
                    :rules="generalRules"
                    outlined
                    dense
                  ></v-select>
                </div>
                <div>
                  <v-select
                    v-model="investType"
                    :items="investTypeList"
                    label="Investment type"
                    :rules="generalRules"
                    outlined
                    dense
                  ></v-select>
                </div>
                <div class="mb-2">
                  <DatePicker v-model="investDate" label="Investment date" :rules="generalRules" />
                </div>
                <div v-if="investType === 'Payroll'">
                  <v-select
                    v-model="payrollNameId"
                    :items="payrollNameList"
                    item-text="ShortName"
                    item-value="Id"
                    label="Payroll name"
                    :rules="generalRules"
                    outlined
                    dense
                  ></v-select>
                </div>
                <div v-if="investType === 'Payroll' && investStatus === 'Provisional'">
                  <v-select
                    v-model="payrollToInvest"
                    :items="payrollToInvestList"
                    item-value="Value"
                    item-text="Text"
                    label="Payroll to invest"
                    :rules="generalRules"
                    outlined
                    dense
                  ></v-select>
                </div>
                <div>
                  <v-text-field v-model="reference" label="Reference" outlined dense></v-text-field>
                </div>
                <div v-if="investStatus === 'Final'">
                  <v-select
                    v-model="provisionalInvest"
                    :items="provisionalInvestList"
                    item-text="ShortName"
                    item-value="Id"
                    label="Provisional investment"
                    :rules="generalRules"
                    outlined
                    dense
                  ></v-select>
                </div>
              </v-col>
              <v-col class="ml-8" cols="4">
                <div v-if="investType === 'Payroll' || investType === 'Specific Cycle'">
                  <v-checkbox
                    label="Leavers"
                    v-model="selectedCheckboxes"
                    value="leavers"
                    :rules="checkboxesRules"
                  ></v-checkbox>
                  <v-checkbox
                    label="Switches"
                    v-model="selectedCheckboxes"
                    value="switches"
                    :rules="checkboxesRules"
                  ></v-checkbox>
                  <v-checkbox
                    label="Transfers"
                    v-model="selectedCheckboxes"
                    value="transfers"
                    :rules="checkboxesRules"
                  ></v-checkbox>
                  <v-checkbox
                    label="Charges"
                    v-model="selectedCheckboxes"
                    value="charges"
                    :rules="checkboxesRules"
                  ></v-checkbox>
                  <v-checkbox
                    label="Lifestyle switches"
                    v-model="selectedCheckboxes"
                    value="lifestyleSwitches"
                    :rules="checkboxesRules"
                  ></v-checkbox>
                </div>
              </v-col>
            </v-row>
          </v-form>
        </v-tab-item>
        <v-tab-item>
          <InvestFunds
            v-if="investType != 'Dividend Allocation'"
            :investFunds="investFunds"
            :reportList="reportList"
          />
          <v-row class="mt-2" v-else>
            <v-col cols="6" :style="{ maxWidth: formMaxWidth + 'px' }">
              <v-select
                v-model="dividendAllocation.manager"
                :items="managerList"
                label="Manager"
                :rules="generalRules"
                item-value="ManagerId"
                item-text="ManagerName"
                @change="getFundList"
                outlined
                dense
              ></v-select>
              <v-select
                v-model="dividendAllocation.fund"
                :items="fundList"
                label="Fund"
                :rules="generalRules"
                item-value="PortfolioId"
                item-text="PortfolioName"
                outlined
                dense
              ></v-select>
              <DatePicker v-model="dividendAllocation.date" label="Allocation date" :rules="generalRules" />
              <v-radio-group v-model="dividendAllocation.type" row>
                <template v-slot:label>
                  <span class="body-1 mr-5">Allocation Type</span>
                </template>
                <v-radio label="Units" value="Units"></v-radio>
                <v-radio label="Value" value="Value"></v-radio>
              </v-radio-group>
              <v-text-field
                type="Number"
                v-model="dividendAllocation.unitsValue"
                label="Units / Value"
                outlined
                dense
              ></v-text-field>
              <v-text-field
                type="Number"
                v-model="dividendAllocation.CurrentPrice"
                label="Current Price"
                outlined
                dense
              ></v-text-field>

              <div>
                <v-btn @click="onRunInvest" outlined color="primary">Allocate Dividends</v-btn>
              </div>
            </v-col>
          </v-row>
        </v-tab-item>
        <v-tab-item>
          <InvestReports
            :reportList="reportList"
            :loading="isReportsLoading"
            :isRunInvestSuccessful="isRunInvestSuccessful"
            :investRunId="investRunId"
            :investRunUID="investRunUID"
          />
        </v-tab-item>
      </v-tabs-items>
    </v-tabs>
    <v-footer padless fixed outlined class="pl-5 pr-5 pt-3 pb-3" color="white" elevation="3">
      <InvestBtns
        @next="onNext"
        @cancel="onCancel"
        @runInvest="onRunInvest"
        @clearInvestment="clearInvestment"
        :currentTab="currentTab"
        :reportList="reportList"
      />
    </v-footer>
    <v-dialog v-model="clearDialog" width="600">
      <v-card>
        <v-card-title> Clear Investment </v-card-title>
        <v-card-text class="pb-0 pt-4">
          <v-select
            :items="investStatusList"
            v-model="clearStatus"
            label="Investment Status"
          ></v-select>
          <v-select :items="investTypeList" v-model="clearType" label="Investment Type"> </v-select>
          <v-select
            :items="investList"
            v-model="clearSelected"
            label="Investment Run"
            item-value="Reference"
            item-text="Description"
          >
          </v-select>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" outlined @click="clearDialog = false">Cancel</v-btn>
          <v-btn color="primary" depressed @click="clearInvestmentRun">Clear</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import DatePicker from '@/components/formControls/DatePicker.vue';
import InvestFunds from './InvestFunds.vue';
import InvestBtns from './InvestBtns.vue';
import InvestReports from './InvestReports.vue';

export default {
  name: 'Investment',
  components: { DatePicker, InvestFunds, InvestBtns, InvestReports },

  data() {
    return {
      currentTab: 0,
      investRunId: 0,
      investRunUID: "00000000-0000-0000-0000-000000000000",
      investStatus: null,
      investStatusList: ['Provisional', 'Final'],
      investType: null,
      clearDialog: false,
      investTypeList: [
        'Payroll',
        'Specific Cycle',
        'Dividend Allocation',
        'Bulk Switch',
        'Maintenance Charges',
        'Switch Buys',
        'Tagged Group',
        'Lifestyle Profile Adjustment',
      ],
      investDate: new Date().toISOString(),
      payrollNameId: null,
      payrollNameList: [],
      payrollToInvest: null,
      payrollToInvestList: [],
      reference: null,
      provisionalInvest: null,
      provisionalInvestList: [],
      selectedCheckboxes: [],

      dividendAllocation: {
        manager: null,
        fund: null,
        date: null,
        type: null,
        unitsValue: null,
        currentPrice: null
      },

      managerList: [],
      fundList: [],

      generalRules: [(v) => !!v || 'Required'],
      checkboxesRules: [
        (v) =>
          this.investStatus === 'Provisional' && this.investType === 'Specific Cycle'
            ? !!v.length || 'At list one of checkboxes should be selected'
            : true,
      ],

      isFormValid: false,
      investFunds: [],
      formMaxWidth: 500,
      collectedData: {},
      reportList: [],
      isReportsLoading: false,
      isRunInvestSuccessful: true,

      clearStatus: '',
      clearType: '',
      clearSelected: '',
      investList: [],
    };
  },

  computed: {
    currentPlanId() {
      return this.$store.getters.currentPlanId;
    },
    selectedFunds() {
      return this.investFunds.filter((fund) => fund.selected === true);
    },
    payrollName() {
      if (this.payrollNameList.length && this.payrollNameId)
        return this.payrollNameList.find((p) => p.Id === this.payrollNameId).ShortName;
      return null;
    },
  },

  watch: {
    async clearStatus() {
      await this.getInvestedList();
    },
    async clearType() {
      await this.getInvestedList();
    },
    investStatus() {
      if (this.investStatus && this.payrollNameId && this.investDate) this.getPayrollToInvestList();
      if (this.investStatus && this.investType && this.investDate)
        this.getProvisionalInvestmentList();
    },
    investType() {
      if ((this.investStatus && this.investType && this.investDate && this.payrollNameId) || this.investStatus == "Final")
        this.getProvisionalInvestmentList();
      
    },
    payrollNameId() {
      if (this.investStatus && this.payrollNameId && this.investDate) this.getPayrollToInvestList();
      if (this.investStatus && this.investType && this.investDate && this.payrollNameId)
        this.getProvisionalInvestmentList();
    },
    investDate() {
      if (this.investStatus && this.investType && this.investDate)
        this.getProvisionalInvestmentList();
      if (this.investStatus && this.investDate && this.payrollNameId) this.getPayrollToInvestList();
    },
    currentPlanId() {
      this.getPayrollNameList();
      if (this.investStatus && this.investDate && this.payrollNameId) this.getPayrollToInvestList();
      if (this.investStatus && this.investType && this.investDate && this.payrollNameId)
        this.getProvisionalInvestmentList();
    },
  },

  created() {
    this.getPayrollNameList();
  },

  methods: {
    async clearInvestmentRun() {
      try {
        if (this.clearStatus !== '' && this.clearType !== '') {
          const response = await this.$api.post(
            `/invest/ClearInvestment?planId=${this.currentPlanId}&investRunId=${this.clearSelected}&investStatus=${this.clearStatus}`
          );
          if (response.data.Value >= 0) {
            this.clearDialog = false;
            await this.getInvestedList();
          }
        }
      } catch (err) {
        console.log(err);
      }
    },
    clearInvestment() {
      this.clearDialog = true;
    },
    async getInvestedList() {
      try {
        this.investList = [];
        if (this.clearStatus !== '' && this.clearType !== '') {
          const response = await this.$api.get(
            `/invest/GetInvestmentList?planId=${this.currentPlanId}&investType=${this.clearType}&investStatus=${this.clearStatus}`
          );
          this.investList = response.data;
          this.clearSelected = '';
        }
      } catch (err) {
        console.log(err);
      }
    },
    onNext() {
      this.isFormValid = this.$refs.form.validate();
      if (this.isFormValid) {
        this.currentTab += 1;
        const data = {
          InvestmentStatus: this.investStatus,
          InvestmentType: this.investType,
          Payroll: this.payrollName,
          InvestmentDate: this.investDate,
          PlanId: this.currentPlanId,
        };

        if (this.investType == "Dividend Allocation"){
          this.getManagerList();
          if (this.investStatus == "Final" && this.provisionalInvest){
            this.loadProvisionalDividendRun();
          }
        } else {
          this.loadFunds(data);
        }
      }
    },

    async loadProvisionalDividendRun(){
      try {
        let response = await this.$api.get(`/invest/GetProvisionalRunDividendData?investRunId=` + this.provisionalInvest)
        let data = response.data;
        if (data){
          this.dividendAllocation.manager = data["ManagerId"];
          this.dividendAllocation.fund = data["FundId"];
          this.dividendAllocation.date = data["InvestDate"];
          this.dividendAllocation.type = data["Type"];
          this.dividendAllocation.unitsValue = data["Units"];

          this.getFundList(data["ManagerId"]);
          
        }


      } catch(err){
        console.log(err);
      } finally {
        //
      }
    },

    onCancel() {
      this.currentTab = 0;
      this.investStatus = null;
      this.investType = null;
      this.investDate = null;
      this.payrollNameId = null;
      this.payrollToInvest = null;
      this.reference = null;
      this.provisionalInvest = null;

      this.leavers = false;
      this.switches = false;
      this.transfers = false;
      this.charges = false;
      this.lifestyleSwitches = false;

      this.managerList = [];
      this.fundList = [];
      this.dividendAllocation = {
        manager: null,
        fund: null,
        date: null,
        type: null,
        unitsValue: null,
        currentPrice: null
      }

    },

    mapChackboxes(type) {
      return !!this.selectedCheckboxes.find((v) => v === type);
    },

    onRunInvest() {
      const data = {
        InvestmentStatus: this.investStatus,
        InvestmentType: this.investType,
        Payroll: this.payrollName,
        InvestmentDate: this.investDate,
        PlanId: this.currentPlanId,
        PayrollId: this.payrollToInvest,
        SelectedFunds: this.selectedFunds,
        Reference: this.reference,
        Leavers: this.mapChackboxes('leavers'),
        Switches: this.mapChackboxes('switches'),
        Transfers: this.mapChackboxes('transfers'),
        Charges: this.mapChackboxes('charges'),
        LifestyleSwitches: this.mapChackboxes('lifestyleSwitches'),
        AllocateDividendsFields: this.dividendAllocation,
      };
      if (this.provisionalInvest) data.ProvisionalInvestmentId = this.provisionalInvest;
      this.runInvestment(data);
      this.currentTab += 1;
    },

    async getPayrollNameList() {
      try {
        const response = await this.$api.get(
          `/picklists/GetPickList?planId=${this.currentPlanId}&listType=payroll`
        );
        this.payrollNameList = response.data;
      } catch (error) {
        console.log(error.message);
      }
    },

    async getPayrollToInvestList() {
      try {
        const response = await this.$api.get(
          `/invest/GetImportedPayrollList?planId=${this.currentPlanId}&investStatus=${this.investStatus}&payroll=${this.payrollName}&investDate=${this.investDate}`
        );
        this.payrollToInvestList = response.data;
      } catch (error) {
        console.log(error.message);
      }
    },

    async getProvisionalInvestmentList() {
      try {
        const response = await this.$api.get(
          `/invest/GetProvisionalInvestmentList?planId=${this.currentPlanId}&investStatus=${this.investStatus}&payroll=${this.payrollName}&investType=${this.investType}&investDate=${this.investDate}`
        );
        this.provisionalInvestList = response.data;
      } catch (error) {
        console.log(error.message);
      }
    },

    async loadFunds(data) {
      try {
        const response = await this.$api.post(`/invest/LoadFundsToInvest`, data);
        this.investFunds = response.data;
      } catch (error) {
        console.log(error.message);
      }
    },

    async runInvestment(data) {
      this.isReportsLoading = true;
      this.isRunInvestSuccessful = true;
      this.investRunId = 0;
      this.investRunUID = "00000000-0000-0000-0000-000000000000";
      try {

        let response;
        if (data.InvestmentType == "Dividend Allocation"){
          response = await this.$api.post(`/invest/AllocateDividends`, data);
        } else {
          response = await this.$api.post(`/invest/RunInvestment`, data);
        }
        
        if (response.data.Value > 0) {
          this.$store.commit('setNotificationMessage', {
            type: 'success',
            text: 'Investment process was successful',
          });

          this.investRunId = response.data.Value;
          this.investRunUID = response.data.Msg;

          this.getReportList(response.data.Value);
        }
      } catch (error) {
        console.log(error.message);
        this.isRunInvestSuccessful = false;
      } finally {
        this.isReportsLoading = false;
      }
    },

    async getReportList(runId) {
      try {
        const response = await this.$api.get('/invest/GetReportLinks?runId=' + runId);

        this.reportList = response.data;
      } catch (error) {
        console.log(error.message);
      }
    },

    async getManagerList() {
      try {
        let response = await this.$api.get('/funds/getManagerList');
        var data = response.data;
        this.managerList = data;
      } catch (err) {
        console.error(err);
      }
    },

    async getFundList(managerId) {
      this.loading = true;
      try {
        const response = await this.$api.get('/Funds/GetFundList?managerId=' + managerId);
        this.fundList = response.data;
      } catch (error) {
        console.log(error.message);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.investment {
  margin-bottom: 20px;
  padding-left: 30px;
  padding-right: 30px;
}
.v-input--selection-controls {
  margin-top: 0;
}
</style>
